import { CompareReportDataPoint } from '@modules/quantify/store/types';
import { Typography } from '@mui/material';
import { GridRenderCellParams } from '@mui/x-data-grid-pro';

interface renderCompareAbsoluteDiffCellProps {
  params: GridRenderCellParams<CompareReportDataPoint, string, unknown>;
}

export const renderCompareAbsoluteDiffCell = ({
  params,
}: renderCompareAbsoluteDiffCellProps) => {
  const value = params.row.absoluteDelta;

  const getTypographyColor = () => {
    if (value > 0) {
      return 'success.light';
    }
    if (value < 0) {
      return 'error.light';
    }
    return 'text.primary';
  };

  return (
    <Typography
      variant="body2"
      sx={{
        color: getTypographyColor(),
      }}
      fontWeight={value === 0 ? undefined : 550}
    >
      {params.value}
    </Typography>
  );
};
